import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link, NavLink } from "react-router-dom";
import "./dropdown.css";
// # assets
import { ReactComponent as ArrowDown } from "../../../assets/icons/arrow-down.svg";
import { ReactComponent as ArrowRight } from "../../../assets/icons/arrow-right.svg";

function Dropdown({ items, title, icon, path = "/", key }) {
  const [show, setShow] = useState(false);

  const toggleMenu = () => setShow(!show);

  return (
    <div key={key} onMouseEnter={toggleMenu} onMouseLeave={toggleMenu} className="dropdown">
      <Link className="inline-block" to={path}>
        {title} <ArrowDown className="ml-2 path:stroke-primary" />
      </Link>

      {show && (
        <ul className="dropdown__menu">
          {items.map(({ title, key, path, hoverBG }) => (
            <NavLink to={path} key={key}>
              <li className={`bg--${hoverBG}`}>
                <span>{title}</span>
                {icon && <ArrowRight />}
              </li>
            </NavLink>
          ))}
        </ul>
      )}
    </div>
  );
}

export default Dropdown;

Dropdown.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      key: PropTypes.string,
      path: PropTypes.string,
    }),
  ),
  title: PropTypes.string,
  icon: PropTypes.bool,
  path: PropTypes.string,
};
